module.exports = "/assets/site/images/camp_placeholder_sq.jpg?55c26f6352ce89af5ec70c9d29017c2c";